import {FETCH_TUITION} from "../../actions";

export default (state = [], action) => {
    switch (action.type) {
        case FETCH_TUITION:
            return action.payload;
        default:
            return state;
    }
};